export default {"src":"/_next/static/media/empty-state-presentations.06b2156b.svg","height":93,"width":90,"blurWidth":0,"blurHeight":0};